// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ip1G","clinicsSelect":"styles_clinicsSelect__i0mhe"};